import { Form, Input, Modal } from "antd";
import { useEffect } from "react";

const AddItemSensitivity = ({ isOpen, onOk, onCancel, editMode, itemData }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (editMode && itemData) {
      form.setFieldsValue({
        title_en: itemData.locales?.find(loc => loc.languageCode === "en")?.name || "",
        title_ar: itemData.locales?.find(loc => loc.languageCode === "ar")?.name || "",
      });
    } else {
      form.resetFields();
    }
  }, [editMode, itemData, form, isOpen]);

  const handleOk = () => {
    form.validateFields().then(values => {
      onOk(values);
    });
  };

  return (
    <>
      <Modal
        title={editMode ? "Edit Item Sensitivity" : "Add Item Sensitivity"}
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={handleOk}
        okText="Save"
      >
        <Form
          form={form} 
          layout="vertical"
          initialValues={{
            remember: true,
          }}
          style={{ marginTop: 24 }}
          autoComplete="off"
        >
          <Form.Item
            label="Item Sensitivity Name (English)"
            name="title_en"
            rules={[
              {
                required: true,
                message: "Please enter your Item Sensitivity Name (English)",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Item Sensitivity Name (Arabic)"
            name="title_ar"
            rules={[
              {
                required: true,
                message: "Please enter your Item Sensitivity Name (Arabic)!",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default AddItemSensitivity;
